<template>
  <div class="unBound">
    <div v-for="(item, i) in couponList" :key="i" class="unboundcell">
      <div class="unBoundTitle">
        <div class="information">
          <div clsss="info">
            <div class="money">
              <span class="symbol">￥</span>
              <span class="currency">{{ item.moneyInVoucher }}</span>
            </div>
            <div v-if="item.minMoneyToEnable" class="fullNumber">{{ item.minMoneyToEnableDesc }}</div>
            <div v-if="!item.minMoneyToEnable" class="fullNumber">无门槛使用</div>
          </div>
        </div>
        <div class="describe">
          <div class="descTitle">
            <div v-if="item.showType === 2" class="title">智慧脸绑定专享</div>
            <div v-if="item.showType === 1" class="title">智慧脸达标专享</div>
            <div class="reward">奖励券</div>
          </div>

          <div v-if="item.showType === 2" class="goBind">绑定药帮忙后立即到账</div>

          <div class="progre" v-if="item.showType === 1">
            <popover :bar-list="proBar.standardsDataList" :rule-level="proBar.standardsRuleVersion">
              <span class="processNum">
                <van-progress :percentage="proBar.ratio" :show-pivot="false" color="#FEC371" />
              </span>
            </popover>
            <span class="standard">已达标{{ proBar.ratio }}%</span>
          </div>

          <div class="rule" v-if="item.showType === 1">
            <div class="iconInfo">
              <img src="~@/assets/problem.png" />
            </div>
            <popoverRule>
              <div class="ruleDesc">规则说明</div>
            </popoverRule>
          </div>
        </div>

        <div class="bind">
          <van-button round type="info" color="#FBF0DA" @click="handleBind">立即绑定</van-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import popover from "../popover/index.vue"
import popoverRule from "../popover/rule"
import { bind_ec } from "@/utils/appMe.js"

export default {
  components: { popover, popoverRule },
  props: {
    // 优惠券列表
    couponList: {
      type: Array,
      default: () => []
    },
    // 机构信息
    organSign: {
      type: Object,
      default: () => {}
    },
    proBar: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      showBind: false,
      showDialog: false
    }
  },
  methods: {
    format(percentage) {
      return percentage <= 100 ? `已达标 ${percentage}%` : ""
    },
    handleBind() {
      window.webSdk.track("pCkgtgLm", { type: "未绑定-点击绑定" })
      // 调用app原生绑定
      bind_ec()
    }
  }
}
</script>
<style scoped>
.unBound {
  width: 345px;
}
.unboundcell {
  margin-bottom: 10px;
}
.unBoundTitle {
  display: flex;
  position: relative;
  width: 345px;
  height: 110px;
  background: url("~@/assets/unbind.png") no-repeat;
  background-size: 100% 100%;
}
.information {
  text-align: center;
  width: 115px;
  height: 110px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.info {
  display: inline-block;
}

.symbol {
  font-size: 14px;
  color: #eb431c;
  font-weight: 600;
  margin-right: -4px;
}
.currency {
  font-family: "Alternate";
  letter-spacing: -1px;
  font-size: 35px;
  color: #eb431c;
  margin-right: 6px;
}
.fullNumber {
  font-family: "Alternate";
  font-size: 13px;
  color: #e13f19;
  font-weight: 400;
}
.describe {
  widows: 220px;
  height: 110px;
  display: flex;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.bind {
  position: absolute;
  top: 35%;
  right: 12px;
}
.describe .title {
  font-family: PingFangSC-Medium, PingFang SC;
  height: 22px;
  font-size: 16px;
  font-weight: 500;
  color: #ffffff;
  margin-top: 12px;
  margin-bottom: 5px;
  line-height: 22px;
}
.reward {
  font-family: PingFangSC-Semibold, PingFang SC;
  width: 38px;
  height: 16px;
  background: #ffdcbf;
  font-size: 10px;
  font-weight: 600px;
  color: #eb431c;
  text-align: center;
  line-height: 16px;
  border-radius: 2px;
}
.goBind {
  font-family: PingFangSC-Regular, PingFang SC;
  width: 120px;
  height: 55px;
  font-size: 12px;
  font-weight: 400;
  color: #ffffff;
  line-height: 55px;
}
.progre {
  height: 20px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 8px;
}
.progre .pop {
  /* 兼容 */
  display: inline-block;
}
.processNum {
  display: flex;
}
.van-progress {
  width: 60px;
  height: 8px;
  display: inline-block;
  background: #ffffff;
  border: none;
}
.standard {
  font-family: PingFangSC-Semibold, PingFang SC;
  height: 14px;
  font-size: 10px;
  font-weight: 600;
  color: #ffebcf;
  line-height: 14px;
  margin-left: 8px;
  /* 兼容 */
  display: inline-block;
}
.rule {
  height: 13px;
  display: flex;
  align-items: center;
  margin-top: 5px;
}
.iconInfo {
  width: 13px;
  height: 13px;
  overflow: hidden;
  margin-right: 3px;
  position: relative;
  /* top: 0; */
  bottom: 1px;
}
.iconInfo img {
  display: block;
  height: 100%;
  width: 100%;
}
.ruleDesc {
  font-family: PingFangSC-Regular, PingFang SC;
  height: 13px;
  line-height: 13px;
  font-size: 12px;
  font-weight: 400;
  color: #ffffff;
}
.bind {
  display: flex;
  align-items: center;
}
.van-button {
  width: 80px;
  height: 28px;
  line-height: 28px;
  background: #fbf0da;
}
.van-button__text {
  font-family: PingFangSC-Semibold, PingFang SC;
  height: 16px;
  font-size: 11px;
  font-weight: 600;
  color: #fb683f;
  line-height: 16px;
  display: block;
  margin: 0 auto;
}
</style>
